import {FIELD_TYPE} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
const {INPUT, SELECT, DATE, COLOR} = FIELD_TYPE;
const dataFields: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã HSX",
    name: "id",
    disable: true,
  },
  {
    type: INPUT,
    label: "Tên HSX",
    name: "name",
    rules: [{required: true, message: "Chưa nhập tên nhà cung cấp"}],
  },
  {
    type: INPUT,
    label: "Địa chỉ",
    name: "address",
  },
  {
    type: INPUT,
    label: "Người đại diện",
    name: "representative",
  },
  {
    type: INPUT,
    label: "Điện thoại",
    name: "phone",
  },
  {
    type: INPUT,
    label: "Email",
    name: "email",
  },
  {
    type: INPUT,
    label: "Các nhóm mặt hàng",
    name: "commodityGroups",
  },
  {
    type: SELECT,
    label: "Trạng thái",
    name: "status",
    options: [
      {value: 0, label: "Hoạt động"},
      {value: 1, label: "Dừng hoạt động"},
    ],
  },
  {
    type: INPUT,
    label: "Ghi chú",
    name: "note",
  },
];
export {dataFields};
